export default __webpack_public_path__ + "static/media/3.e655a399.jpg";